module.exports = __webpack_public_path__ + "static/img/flag-ch@2x.1dc70fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag-ch@2x.png
// module id = ybea
// module chunks = 7